import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Environment } from "@core/config/environment";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { CurrentProfile } from "@domain/currentProfile/currentProfile";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { createToast } from "@ui/toasts/utils";
import { Tooltipable } from "@ui/tooltips/tooltipable";
import { FacebookBlackIcon, LinkedInBlackIcon, LinkIconBlack, TwitterBlackIcon, WhatsappBlackIcon } from "./icons";
import { row } from "./layout";

interface ShareOnSocialMediaProps {
	message: string;
	path?: string;
}

export const ShareOnSocialMedia: React.FC<ShareOnSocialMediaProps> = ({ message, path }) => {
	const { facebookService, linkedinService, twitterService, whatsappService } = useServices();
	const currentProfile = useCurrentProfile();

	const shares = [
		{
			tooltipeTitle: "facebook_tooltip",
			renderIcon: () => <FacebookBlackIcon />,
			onClick: (currentProfile: CurrentProfile, message: string) => {
				facebookService.openShareDialog(`${Environment.APP_BASE_URL}${path ?? Path.Profile(currentProfile)}`, message);
			},
		},
		{
			tooltipeTitle: "twitter_tooltip",
			renderIcon: () => <TwitterBlackIcon />,
			onClick: (currentProfile: CurrentProfile, message: string) => {
				// console.log("twitter: ", `${Config.APP_BASE_URL}${path ?? Path.Profile(currentProfile)}`);

				twitterService.openShareDialog(`${Environment.APP_BASE_URL}${path ?? Path.Profile(currentProfile)}`, message);
			},
		},
		{
			tooltipeTitle: "linkedin_tooltip",
			renderIcon: () => <LinkedInBlackIcon />,
			onClick: (currentProfile: CurrentProfile, message: string) => {
				linkedinService.openShareDialog(`${Environment.APP_BASE_URL}${path ?? Path.Profile(currentProfile)}`, message);
			},
		},
		{
			tooltipeTitle: "whatsapp_tooltip",
			renderIcon: () => <WhatsappBlackIcon />,
			onClick: (currentProfile: CurrentProfile) => {
				// console.log("Whatsapp: ", `${Config.APP_BASE_URL}${path ?? Path.Profile(currentProfile)}`);

				whatsappService.openShareDialog(`${Environment.APP_BASE_URL}${path ?? Path.Profile(currentProfile)}`, message);
			},
		},
		// {
		// 	tooltipeTitle: "instagram_tooltip",
		// 	renderIcon: () => <InstagramBlackIcon />,
		// 	onClick: (currentProfile: CurrentProfile) => {
		// 		console.log("insta: ");

		// 		instagramService.openShareDialog(`${Config.APP_BASE_URL}${path ?? Path.Profile(currentProfile)}`, message);
		// 	},
		// },
		{
			tooltipeTitle: "clipboard_tooltip",
			renderIcon: () => <LinkIconBlack />,
			onClick: () => {
				// console.log("copy: ", `${Config.APP_BASE_URL}${path}`);
				// console.log("path: ", path ? `${Config.APP_BASE_URL}${path}` : window.location.href);

				navigator.clipboard.writeText(path ? `${Environment.APP_BASE_URL}${path}` : window.location.href);
				createToast(I18n.t("success"), I18n.t("profile.card.invite.action.copied_link"), "success");
			},
		},
	] as const;
	return currentProfile ? (
		<Container>
			{shares.map(({ tooltipeTitle, renderIcon, onClick }) => (
				<Wrapper key={tooltipeTitle} onClick={() => onClick(currentProfile, message)}>
					<Tooltipable text={I18n.t(`profile.card.invite.action.${tooltipeTitle}`)} offset={-3} dark={true}>
						{renderIcon()}
					</Tooltipable>
				</Wrapper>
			))}
		</Container>
	) : null;
};

const Container = styled.div`
	${row("S", "center", "center")}
`;

const Wrapper = styled.div`
	cursor: pointer;
	> svg {
		:hover {
			opacity: 0.8;
		}
	}
`;
